import { gql } from '@apollo/client';

const assetHierarchyLevel = gql`
  fragment assetHierarchyLevel on AssetHierarchyLevel {
    id
    name
    label
    level
    assetTypeId
    triggers {
      image
      price
      equipments
    }
  }
`;

const assetHierarchy = gql`
  fragment assetHierarchy on AssetHierarchy {
    id
    code
    name
    itemId
  }
`;

const fragments = { assetHierarchyLevel, assetHierarchy };
export default fragments;
